import React, { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/ui/button';
import Dialog from '@/components/ui-bridge/core/Dialog';
import DialogActions from '@/components/ui-bridge/core/DialogActions';
import DialogContent from '@/components/ui-bridge/core/DialogContent';
import DialogContentText from '@/components/ui-bridge/core/DialogContentText';
import DialogTitle from '@/components/ui-bridge/core/DialogTitle';
import Grid from '@/components/ui-bridge/core/Grid';
import PropTypes from 'prop-types';

import RedeSeguros from '@/components/FeatureModal/Icons/rede-confiax.png';

const COOKIE_NAME = 'IKnowAboutRedeSeguros';

const FeatureModal = ({ feature }) => {
  const { formatMessage } = useIntl();

  const [open, setOpen] = useState(() => {
    return document.cookie.replace(/(?:(?:^|.*;\s*)IKnowAboutRedeSeguros\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'true';
  });

  const features = useMemo(() => ({
    visitaDigital: {
      title: formatMessage({ id: 'REDE_SEGUROS_TITLE_MESSAGE' }),
      description: formatMessage({ id: 'REDE_SEGUROS_BODY_MESSAGE' }),
      img: RedeSeguros,
      external: 'https://app.ladobom.com',
    },
  }), [formatMessage]);

  const handleClose = useCallback(() => {
    document.cookie = `${COOKIE_NAME}=true; expires=Fri, 31 Dec 2030 23:59:59 GMT; path=/`;
    setOpen(false);
  }, []);

  const config = features[feature];

  if (!config) return null;

  const instructions = config.external ? (
    <p>
      {formatMessage({ id: 'CLICK' })}
      &nbsp;
      <a
        href={config.external}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block text-[#949494] underline font-bold"
      >
        {formatMessage({ id: 'HERE' })}
      </a>
      &nbsp;
      {formatMessage({ id: 'TO_KNOW_MORE' })}.
    </p>
  ) : null;

  return (
    <Dialog open={open} maxWidth="md" aria-labelledby="responsive-dialog-title">
      <Grid container alignItems="center" className="max-w-[700px] p-[50px_10px_10px]">
        <Grid item xs={4} className="self-end p-2.5">
          <img src={config.img} alt="Feature" className="w-full" />
        </Grid>
        <Grid item xs={8}>
          <DialogTitle id="responsive-dialog-title" className="px-6 pt-5 text-lg font-semibold text-slate-900">
            {config.title}
          </DialogTitle>
          <DialogContent className="px-6 pb-0 pt-2 text-sm text-slate-700">
            <DialogContentText component="div" className="text-sm leading-relaxed text-slate-700">
              {config.description}
              <br />
              <br />
              <div>{instructions}</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="flex items-center justify-end gap-2 px-6 pb-5 pt-2">
            <Button
              className="font-bold text-[#5A8192] text-[22px] bg-transparent hover:bg-transparent shadow-none"
              onClick={handleClose}
            >
              {formatMessage({ id: 'OK' })}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
};

FeatureModal.propTypes = {
  feature: PropTypes.string.isRequired,
};

export default FeatureModal;
